export function isNewOrganization(organization?: Organization) {
  return (organization?.memberCount || 0) <= 1;
}
